import dayjs from 'dayjs';

const getOptionId = (value: any) => value?.id ?? value;

const isValidDayjs = (value: any) => dayjs(value).isValid();

const formatDate = (value: any) => {
    if (!value || !isValidDayjs(value)) return undefined;
    if (typeof value?.format === 'function') return value.format('YYYY-MM-DD');
    if (value instanceof Date) return value.toISOString().slice(0, 10);
    return value;
};

const formatStartOfDay = (value: any) =>
    value && isValidDayjs(value) ? dayjs(value).startOf('day').toISOString() : undefined;

const formatEndOfDay = (value: any) =>
    value && isValidDayjs(value) ? dayjs(value).endOf('day').toISOString() : undefined;

export const normalizeVisitsQueryParams = (params: Record<string, any>) => {
    const { idEstadoSRT: _selectedSrtState, ...queryParams } = params;

    const normalizedParams = {
        ...queryParams,
        idOrganizacion: getOptionId(queryParams.idOrganizacion),
        idContrato: getOptionId(queryParams.idContrato),
        idOrganismo: getOptionId(queryParams.idOrganismo),
        idEstablecimiento: getOptionId(queryParams.idEstablecimiento),
        fecha: formatDate(queryParams.fecha),
        fechaInicio: formatStartOfDay(queryParams.fechaInicio),
        fechaFin: formatEndOfDay(queryParams.fechaFin)
    };

    return Object.fromEntries(
        Object.entries(normalizedParams).filter(
            ([, value]) =>
                value !== '' &&
                value !== null &&
                value !== undefined &&
                !(Array.isArray(value) && value.length === 0)
        )
    );
};

